<template>
	<div class="wrapper">
		<div class="weui-msg" v-if="isSuccess === 1">
			<div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
			<div class="weui-msg__text-area">
				<h2 class="weui-msg__title">领券成功</h2>
				<p class="weui-msg__desc">{{resultMsg}}</p>
			</div>
			<div class="weui-msg__opr-area">
				<p class="weui-btn-area">
					<button class="weui-btn weui-btn_primary" @click="back">我的停车券</button>
				</p>
			</div>
		</div>
		<div class="weui-msg" v-else-if="isSuccess === 2">
			<div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
			<div class="weui-msg__text-area">
				<h2 class="weui-msg__title">领券失败</h2>
				<p class="weui-msg__desc">{{resultMsg}}</p>
			</div>
			<div class="weui-msg__opr-area">
				<p class="weui-btn-area">
					<button class="weui-btn weui-btn_default" @click="back">返回</button>
				</p>
			</div>
		</div>
	</div>

</template>

<script>
    import { userGetCoupon } from "../../../api/coupon/userGetCoupon";
    import { getCouponKey } from "../../../api/coupon/rationFee";
    import { pay } from "../../../api/coupon/pay";
    import { mapGetters } from 'vuex'

    export default {
        name: "index",
        data () {
            return {
                taskId: undefined,
                couponvalueId: undefined,
                isGZH: false,
                isMarket: false,
                url: undefined,
                isSuccess: 0,
                resultMsg: undefined
            }
        },
        computed: {
            ...mapGetters(['userOpenid','userPhone'])
        },
        mounted () {
            if (localStorage.getItem('userOpenId')||this.userOpenid  ){
                // console.log('timeStamp',this.GetQueryString('timeStamp'));
                // console.log('taskId',this.$encryptUtil.decrypt(this.GetQueryString('taskId')));
                // console.log('couponId',this.$encryptUtil.decrypt(this.GetQueryString('couponId')));
                // console.log('couponTypeId',this.$encryptUtil.decrypt(this.GetQueryString('couponTypeId')));
                // console.log('saleMoney',this.$encryptUtil.decrypt(this.GetQueryString('saleMoney')));
                this.url = window.location.href;
                if (this.GetQueryString("isGZH")){//后台轮询、按天发放、后台停车券类型里的二维码、公众号里立即发放
                    this.isGZH = true;
                    let form = {
                        bindMethod: 1,
                        openid:  localStorage.getItem('userOpenId')||this.userOpenid,
                        businessPhone: this.userPhone,

                        needuserBindplatenumber: this.GetQueryString('isChecked') == true ? '1' : '0',
                    };
                    if (this.GetQueryString("timeStamp")) {//按天发放
                        form.couponTaskId = this.$encryptUtil.decrypt(this.GetQueryString('taskId'));
                        form.timeStr = this.GetQueryString('timeStamp');
                        form.scanType = 1;
                        this.taskId = this.$encryptUtil.decrypt(this.GetQueryString('taskId'));
                    }else if (this.GetQueryString('couponId')){//后台轮询二维码进入
                        form.couponId = this.$encryptUtil.decrypt(this.GetQueryString('couponId'));
                        form.scanType = 2;
                        this.taskId = this.$encryptUtil.decrypt(this.GetQueryString('taskId'));
                    } else if (this.GetQueryString('isRationFee')) {//公众号立即发放二维码进入
                        form.couponTaskId = this.$encryptUtil.decrypt(this.GetQueryString('taskId'));
                        form.scanType = 3;
                        this.taskId = this.$encryptUtil.decrypt(this.GetQueryString('taskId'));
                    }else if (this.GetQueryString('couponTypeId')) {//后台停车券类型生成二维码进入
                        form.couponTypeId = this.$encryptUtil.decrypt(this.GetQueryString('couponTypeId'));
                        form.scanType = 4;
                    }
                    this.userGetCoupon(form)
                }else {//扫描超市小票进入
                    this.isMarket = true;
                    let form = {
                        bindMethod: 4,
                        openid: localStorage.getItem('userOpenId')||this.userOpenid  ,
                        saleBarcode: this.url.split('?')[1],
                        businessPhone: this.userPhone
                    };
                    this.userGetCoupon(form)
                }
            }
        },
        methods: {
            /*获取地址栏参数**/
            GetQueryString(name) {
                let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                let r = window.location.search.substr(1).match(reg);
                if(r!=null)return unescape(r[2]); return null;
            },
			toPay (res) {
                let payForm = {
                    orderSn: res.data.orderSn,
                    totalAmount: parseFloat(res.data.totalPrice).toFixed(2),
                    goodsType: res.data.goodsType,
                    parkinglotId: this.$encryptUtil.decrypt(this.GetQueryString('parkinglotId')),
                    payType: 13,
                    openId:localStorage.getItem('userOpenId')||this.userOpenid 
                };
                pay(payForm).then(res =>{
                    if (res.code == 200){
                        this.$pay(res)
                    }
                })
			},
            /*用户领券**/
            userGetCoupon (form) {
                userGetCoupon (form).then(res =>{
                    if (res.code === 200){
                        if (this.isGZH){
                            if (this.GetQueryString('saleMoney') && this.$encryptUtil.decrypt(this.GetQueryString('saleMoney')) > 0){//需要支付
                                if (res.msg === "reminderBindPlateNo") {
                                    this.$weui.confirm('您未绑定车牌号，请确认？',{
                                        buttons: [{
                                            label: '去绑定',
                                            type: 'default',
                                            onClick: () => {
                                                this.$router.replace('plateInfo')
                                            }
                                        }, {
                                            label: '去支付',
                                            type: 'primary',
                                            onClick: () =>{
                                                this.toPay(res)
                                            }
                                        }]
                                    })
                                }else {
                                    this.toPay(res)
								}
                            } else {//无需支付
                                this.resultMsg = res.data.couponKey ? res.data.couponKey : '';
                                this.isSuccess = 1;
                                if (res.msg === "reminderBindPlateNo") {
                                    this.$weui.confirm('您未绑定车牌号，请确认？',{
                                        buttons: [{
                                            label: '去绑定',
                                            type: 'default',
                                            onClick: () => {
                                                this.$router.replace('plateInfo')
                                            }
                                        }, {
                                            label: '确认',
                                            type: 'primary',
                                        }]
                                    })
                                }
                            }
                        } else if(this.isMarket){
                            this.isSuccess = 1;
                            this.resultMsg = "超市小票";
                        }
                    } else {
                        this.resultMsg = res.msg;
                        this.isSuccess = 2
                    }
                })
            },
            back () {
                this.$router.replace('personalParkingFee')
            }
        }
    }
</script>

<style scoped>

</style>
